import type { DetectedHdpeContent, DetectedPetContent, DetectedUbcContent, EvidenceUploadMode } from 'api';
import { useState } from 'react';

import { useRepresentativeEvidence } from '../useRepresentativeEvidence/useRepresentativeEvidence';

type RepresentativeType = 'Best' | 'Typical' | 'Worst';

type UseGetRepresentativeEvidenceParams = {
  parentId?: number;
  uploadMode?: EvidenceUploadMode;
  detectedContent: DetectedUbcContent | DetectedPetContent | DetectedHdpeContent | undefined;
};

const getRepresentativeEvidenceIds = (
  detectedContent: DetectedUbcContent | DetectedPetContent | DetectedHdpeContent | undefined,
  type: RepresentativeType
): number[] | undefined => {
  if (!detectedContent) return undefined;
  switch (type) {
    case 'Best':
      return detectedContent.best_load_evidence_ids;
    case 'Typical':
      return detectedContent.typical_load_evidence_ids;
    case 'Worst':
      return detectedContent.worst_load_evidence_ids;
  }
};

export const useGetRepresentativeEvidence = ({
  parentId,
  uploadMode,
  detectedContent,
}: UseGetRepresentativeEvidenceParams) => {
  const [representativeType, setRepresentativeType] = useState<RepresentativeType>('Worst');

  const representativeEvidenceIds = getRepresentativeEvidenceIds(detectedContent, representativeType);

  const { data: representativeEvidence, isLoading: isRepresentativeEvidenceLoading } = useRepresentativeEvidence({
    parentId: parentId || 0,
    representativeEvidenceIds,
    uploadMode,
  });

  return {
    isRepresentativeEvidenceLoading,
    representativeEvidence,
    representativeType,
    setRepresentativeType,
  };
};
